import React, { memo } from "react";
import { connect } from "react-redux";

import Digitain from "@pages/sportsbook/digitaion";
import { getActiveLanguage } from "react-localize-redux";
import "./assets/styles/style.sass";

//It's enough to render just one time with initial props
//So we can use memo to prevent re-rendering
export const OldSportsbook = memo(
	({ sessionId, currentLanguage }) => {
		return (
			<div className={"sportsbook-frame "}>
				<Digitain
					sessionId={sessionId}
					currentLanguage={currentLanguage}
				/>
			</div>
		);
	},
	(oldProps, newProps) => {
		return (
			oldProps.currency === newProps.currency &&
			oldProps.currentLanguage === newProps.currentLanguage
		);
	}
);

const mapStateToProps = (state) => ({
	isAuthenticated: state.auth?.user?.sessionId ?? false,
	sessionId: state.auth.user.sessionId,
	currentLanguage: getActiveLanguage(state.localize).code,
});

const mapDispatchToProps = {};

OldSportsbook.displayName = "OldSportsbook";

export default connect(mapStateToProps, mapDispatchToProps)(OldSportsbook);
